import { Children, ReactNode } from 'react'

const hasVisibleChildren = (
  children: ReactNode,
  isLoading?: boolean,
): boolean => {
  if (isLoading) return true

  return Children.toArray(children).some(
    child => child != null && child !== false,
  )
}

export const PageHeaderTagsRowParts = {
  hasVisibleChildren,
}
